import API from "../commons/Api.js";
import Utils from "../commons/utils.js";
import { eventBus, EVENTS } from "../commons/EventBus.js";

eventBus.on(EVENTS.PAGE_AFTER_RENDERING, function (data) {
  const template = data.template;
  if (template != "eventi") {
    return;
  }

  $('.choose_sub_categoria.eventi').on('click', (e) => {
    $(".choose_sub_categoria.eventi").removeClass("selected");
    $(e.target).addClass("selected");

    $(".container-content.eventi").not(".eventi_mpu").addClass("hide_elem");
    $(".container-content.eventi.container-content-categoryId-" + $(e.target).data("id")).removeClass("hide_elem");

    $(".mostra_altri_eventi").css("display","none");

    if(!$( "#mostra_altri_eventi-"+$(e.target).data("id") ).hasClass( "bottone_carica_altri_eventi_disabled")){
      $("#mostra_altri_eventi-"+$(e.target).data("id")).css("display","block");
    }

  });

  $('.mostra_altri_eventi').on('click',  (e) => {

    Utils.showWaitingLoader();

    let start_paginatore = parseInt($("#mostra_altri_eventi-"+$(e.target).data("id")).attr("data-start")) + 9;

    let id_categoria = parseInt($("#mostra_altri_eventi-"+$(e.target).data("id")).attr("data-id"));

    API.get("site/getLastPostsByCategory", { id: id_categoria, numero_post: 9, start: start_paginatore }, function (resp) {

      var eventi = resp.data;

      if (eventi.length > 0) {

        for (let i = 0; i < eventi.length; i++) {

          let template = window.templates["blocco_evento_passato"];

          template = template.replaceAll("{{image}}", eventi[i].image)
            .replaceAll("{{category}}", eventi[i].category)
            .replaceAll("{{date}}", eventi[i].date)
            .replaceAll("{{title}}", eventi[i].title)
            .replaceAll("{{categoryId}}", id_categoria)
            .replaceAll("{{visibility_class}}", "")
            .replaceAll("{{slug}}", eventi[i].slug);

          $("#eventi-blocco_evento_passato").append(template);

        }

        if(eventi[0]["category_count"] <= $(".container-content.eventi.container-content-categoryId-"+id_categoria).length){
          $("#mostra_altri_eventi-"+id_categoria).hide();
          //debugger
          $("#mostra_altri_eventi-"+id_categoria).addClass("bottone_carica_altri_eventi_disabled");
        }

        $("#mostra_altri_eventi-"+id_categoria).attr("data-start", start_paginatore);

      } else {

        $("#mostra_altri_eventi-"+id_categoria).hide();

      }

      Utils.hideWaitingLoader();

    });

  });
});

